export const unitless = 8;
export const px = '8px';
export const multiple = (multiplier: number) => ({
    px: `${multiplier * 8}px`,
    unitless: multiplier * 8,
    multiple: (additionalMultiplier: number) => multiple(multiplier * additionalMultiplier),
});
// height of a single lined paragraph tag
export const SINGLE_LINE_PARAGRAPH_HEIGHT = 20;
